import Header from "../../Common/header";
import Footer from "../../Common/footer";

const OwlView = () => {

  const buttonStyle = {
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "10px 20px",
    cursor: "pointer",
    marginRight: "10px",
    marginTop: "50px"
  };

  return (
    <><Header /><div>
      <p>Owl View</p>
      <object data="/Ontology.ttl" type="text/turtle" style={{ width: '100%', height: '300px', overflowX: 'auto', margin: '0 auto' }}>
        {/* Fallback content or message for users who can't view ttl files */}
        <p style={{ marginBottom: '25px' }}>Sorry, your browser doesn't support viewing ttl files.</p>
        <a href="http://arcrcticesearch-20220915111649-hostingbucket-admintest.s3-website-us-east-1.amazonaws.com/Ontology.ttl" target="_blank" rel="noopener noreferrer" style={buttonStyle}>
          Download Ontology
        </a>
      </object>

    </div><Footer /></>
  );
};

export default OwlView;
